import BScroll from "@better-scroll/core";
import React, { useEffect, useMemo, useRef, useState } from "react";
import completeIcon from "../../assets/complete.png";
import pendingIcon from "../../assets/pending.png";
import styles from "./index.module.scss";
import { progressListItem } from "../../../../types";
const initBscroll: BScroll | null = null;

interface PropsType {
  progressList: progressListItem[];
}

export default function Progress(props: PropsType) {
  const itemContainer = useRef(null);
  const [bscroll, setBscroll] = useState(initBscroll);
  const { progressList } = props;
  useEffect(() => {
    let startX = 0;
    let index = progressList.findIndex((item) => {
      return item.iconType === 0;
    });

    let progressItem = document.getElementById("progressItem0");
    console.log(index);
    if (index === -1) {
      startX = -(progressItem?.offsetWidth || 123) * 3;
    } else if (index === 0 || index === 1) {
      startX = 0;
    } else {
      startX = -(index - 1) * (progressItem?.offsetWidth || 120);
    }

    const _bscroll = new BScroll(itemContainer.current!, {
      scrollX: true,
      startX: startX,
      eventPassthrough: "vertical",
      bounce: false
    });
    setBscroll(_bscroll);
    console.log(_bscroll);
    return () => {
      _bscroll.destroy();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** 0未完成 1 进行中 2 已完成 */

  const getCircleStyles = (item) => {
    if (item.iconType === 1) {
      return styles.blackCircle;
    } else if (item.iconType === 2) {
      return styles.blackCircle;
    } else {
      return styles.lineCircle;
    }
  };

  return (
    <div className={styles.itemContainer} ref={itemContainer}>
      <div className={styles.itemList}>
        <div id="progress">
          {progressList.map((item, index) => {
            return (
              <div
                id={"progressItem" + index}
                className={styles.progressItem}
                key={index}
              >
                <div className={styles.iconWrpper}>
                  {index !== 0 && (
                    <div className={styles.lineWrapper}>
                      {/* <svg width="72" height="4">
                     <line
                       strokeDasharray="2, 3"
                       y2="0"
                       x2="72"
                       y1="0"
                       x1="0"
                       strokeWidth="3"
                       stroke={
                         index === 0
                           ? "transparent"
                           : item.status === 1
                           ? "#7bae3f"
                           : "#b3b3b3"
                       }
                       fill="none"
                     />
                   </svg> */}
                      <div
                        className={`${styles.line} ${
                          item.iconType === 1 || item.iconType === 2
                            ? styles.blackLine
                            : ""
                        }`}
                      ></div>
                    </div>
                  )}
                  {/* <img
                    alt=""
                    className={styles.icon}
                    src={item.status === 1 ? completeIcon : pendingIcon}
                  /> */}
                  <div className={getCircleStyles(item)}>
                    {item.iconType === 2 ? "✓" : index + 1}
                  </div>
                </div>
                <div className={styles.progressName}>{item.statusDesc}</div>
                <div className={styles.progressDate}>{item.statusTime}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
